import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useAPI from '../api';
import renderFromStructure from '../Pages/Editor/Utils/renderFromStructure';
import decodeBase64Auto from '../Helpers/decode';
const LandingPage = function LandingPage() {
  const API = useAPI();

  const { landingId, activityId } = useParams();
  const [landingPage, setLandingPage] = useState(null);

  useEffect(() => {
    if (landingId)
      API.getLandingPage(
        landingId,
        activityId,
        {},
        (res) => {
          const parsedData = {
            ...res,
            body: JSON.parse(decodeBase64Auto(res?.body)),
          };
          setLandingPage(parsedData);
        },
        () => {}
      );
  }, [landingId]);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        overflow: 'auto',
      }}
    >
      {landingPage?.body && activityId ? (
        renderFromStructure({
          element: landingPage?.body,
          activityId,
        })
      ) : (
        <div />
      )}
    </div>
  );
};

export default LandingPage;
